<template>
  <div>
    <breadcrumb/>
    <PostList category="Conoce a tu Business Partner" />
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>